import React, { createContext } from 'react';

import { DarkStyle, ResolvedTheme, ThemeSetting } from '@/hooks/useThemeSetting';
import { AppMessage } from '@/types/appMessage';
import { DugoutConfig } from '@/types/config';
import { StaffUserSession } from '@/types/staffSession';
import { UserPermissions } from '@/types/user';

export interface AppContextInterface {
  addMessage(level: AppMessage['level'], text: string): void;
  addMessage(message: AppMessage): void;
  addMessage(messages: AppMessage[]): void;
  config: DugoutConfig;
  currentUser: StaffUserSession | null;
  resolvedTheme: ResolvedTheme;
  host: string;
  permissions: UserPermissions | undefined;
  setCurrentUser: (currentUser: StaffUserSession | null) => void;
  setLogoutReason: (reason: string | null) => void;
  themeSetting: ThemeSetting;
  setThemeSetting: (themeSetting: ThemeSetting) => void;
  darkStyle: DarkStyle;
  setDarkStyle: (darkStyle: DarkStyle) => void;
  setPendingRequests: React.Dispatch<React.SetStateAction<string[]>>;
  setHost: (host: string) => void;
  pendingRequests: string[];
  healthieApiKey?: string;
  setHealthieApiKey?: (key: string) => void;
}

const AppContext = createContext({} as AppContextInterface);

export default AppContext;
